import config from "../config";

export const services = {
	addInterest: (emailId, name) =>
		fetch(`${config.host}/addInterest`, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ emailId, name })
		})
			.then(data => {
				console.log(data);
			})
			.catch(err => {
				console.log(err);
			})
};
